import React, { Component } from 'react';

import memoizeOne from 'memoize-one';
import { Redirect } from 'react-router-dom';
import getAlias from '@shootsta/get-alias';
import { replaceBucketKeysWithUrlsInArray } from '@shootsta/client-aws-s3';
import { credentials } from '@shootsta/client-auth';
import { ORGANISATION_ID } from '@shootsta/common-domain-data';
import AuthorisationContext from '../context/AuthorisationContext';
import Error from '../../Error';




import isShootstaOrgId from '../../../common/utils/isShootstaOrgId';
import isShootstaEditor from '../../../common/utils/isShootstaEditor';
import isShootstaAdmin from '../../../common/utils/isShootstaAdmin';
import isShootstaTechSuport from '../../../common/utils/isShootstaTechSupport';
import isShootstaSeniorEditor from '../../../common/utils/isShootstaSeniorEditor';
import isShootstaAccountManager from '../../../common/utils/isShootstaAccountManager';

function formatOrganisation({ orgPackage, ...organisation }) {
  return {
    ...organisation,
    package: orgPackage,
    includedAddonTypes: orgPackage ? orgPackage.includedAddonTypes : [],
    customAddonCosts: orgPackage ? orgPackage.addonCosts : []
  };
}













export default class AuthorisationProvider extends
Component {
  getProviderValue = memoizeOne((selectedOrganisation) => {
    const { organisationMemberships } = this.state;

    if (!selectedOrganisation) {
      return {
        organisationMemberships: organisationMemberships || [],
        isShootsta: false,
        isShootstaEditor: false,
        isShootstaSeniorEditor: false,
        isShootstaAdmin: false,
        isShootstaTechSupport: false,
        isShootstaAccountManager: false,
        isShootstaUser: false,
        selectedOrganisation: {
          organisationId: null,
          includedAddonTypes: [],
          customAddonCosts: [],
          permissions: [],
          preferences: {},
          package: { amendmentsQuantity: 0 }
        },
        updateSelectedOrganisation: this.updateSelectedOrganisation,
        updateSelectedOrganisationData: this.updateSelectedOrganisationData
      };
    }

    return {
      organisationMemberships: organisationMemberships || [],
      isShootsta: isShootstaOrgId(selectedOrganisation.organisationId),
      isShootstaEditor: this.isShootstaEditor(),
      isShootstaSeniorEditor: this.isShootstaSeniorEditor(),
      isShootstaAdmin: this.isShootstaAdmin(),
      isShootstaTechSupport: this.isShootstaTechSupport(),
      isShootstaAccountManager: this.isShootstaAccountManager(),
      isShootstaUser: this.isShootstaUser(),
      isWorkspaceAdmin: this.isWorkspaceAdmin(),
      selectedOrganisation,
      updateSelectedOrganisation: this.updateSelectedOrganisation,
      updateSelectedOrganisationData: this.updateSelectedOrganisationData
    };
  });

  constructor(props) {
    super(props);

    this.state = {
      error: false
    };
  }

  updateSelectedOrganisation = ({ alias }) => {
    const currentAlias = getAlias();
    const { hostname, protocol, port } = window.location;
    const hostUrlSplit = hostname.split('.');
    const newUrl = [...hostUrlSplit];
    const portPart = port ? `:${port}` : '';

    // Scenarios with no alias
    // app.shootsta.com
    // => foo.app.shootsta.com
    if (!newUrl[0].includes(currentAlias)) {
      window.location.href = `${protocol}//${[alias, ...newUrl].join('.')}${portPart}`;

      return;
    }

    // Scenarios with existing alias
    // foo.app.shootsta.com
    newUrl.splice(0, 1, alias);

    window.location.href = `${protocol}//${newUrl.join('.')}${portPart}`;
  };

  updateSelectedOrganisationData = (data) => {
    this.setState(({ selectedOrganisation }) => ({
      selectedOrganisation: {
        ...selectedOrganisation,
        ...data
      }
    }));
  };

  getCurrentOrganisation = (organisationMemberships) => {
    const alias = getAlias();

    const { organisation: currentOrganisation, user } = alias ?
    organisationMemberships.find(
      ({ organisation }) => organisation.alias === alias
    ) || { organisation: null } :
    organisationMemberships[0];

    if (!currentOrganisation) return null;

    return { ...currentOrganisation, user };
  };

  getShootstaOrganisation = (organisationMemberships) => {
    const { organisation: shootstaOrg, user } = organisationMemberships.find(
      ({ organisation }) => organisation.organisationId === ORGANISATION_ID.SHOOTSTA
    ) || { organisation: null, user: null };

    if (!shootstaOrg) return null;

    return { ...shootstaOrg, user };
  };

  getOrganisationById = (
  selectedOrganisationId,
  organisationMemberships) =>
  {
    if (!selectedOrganisationId) {return null;}

    const { organisation: selectedOrganisation, user } = organisationMemberships.find(
      ({ organisation }) => organisation.organisationId === selectedOrganisationId
    ) || {};

    if (!selectedOrganisation) return null;

    return { ...selectedOrganisation, user };
  };

  resolveOrgProfileImages = async (
  memberships,
  selectedOrganisation) =>
  {
    if (!memberships || !memberships.length || !selectedOrganisation) {return;}

    const { organisationId: selectedOrgId } = selectedOrganisation;
    const { apiClient } = this.props;

    try {
      const membershipsWithImages = await replaceBucketKeysWithUrlsInArray({
        apiClient,
        dataArray: memberships.map((membership) => (
        { ...membership, organisationId: membership.organisation.organisationId })
        ),
        substitutedKeys: [{ key: 'organisation', subKeys: ['imageUrl'] }]
      });

      this.setState({
        organisationMemberships: membershipsWithImages,
        // Update the selected org to one with an image
        selectedOrganisation: this.getOrganisationById(selectedOrgId, membershipsWithImages)
      });
    } catch (e) {
      // If we fail to fetch images, just remove all the image references
      const membershipsWithoutImages = memberships.map((membership) => ({
        ...membership,
        organisation: { ...membership.organisation, imageUrl: void 0 }
      }));

      this.setState({
        organisationMemberships: membershipsWithoutImages,
        selectedOrganisation: this.getOrganisationById(selectedOrgId, membershipsWithoutImages)
      });
    }
  };

  isShootstaEditor = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA && (
      isShootstaEditor(membership.role.name, membership.status) ||
      isShootstaSeniorEditor(membership.role.name, membership.status))
    );
  };

  isShootstaSeniorEditor = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA &&
      isShootstaSeniorEditor(membership.role.name, membership.status)
    );
  };

  isShootstaAdmin = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA &&
      isShootstaAdmin(membership.role.name, membership.status)
    );
  };

  isShootstaTechSupport = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA &&
      isShootstaTechSuport(membership.role.name, membership.status)
    );
  };

  isShootstaAccountManager = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA &&
      isShootstaAccountManager(membership.role.name, membership.status)
    );
  };

  isShootstaUser = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId === ORGANISATION_ID.SHOOTSTA &&
      membership.status === 'ACCEPTED'
    );
  };

  isWorkspaceAdmin = () => {
    const { organisationMemberships = [] } = this.state;

    return organisationMemberships.
    some(
      (membership) => membership.organisation.organisationId !== ORGANISATION_ID.SHOOTSTA &&
      membership.role.name === 'ADMIN' && membership.status === 'ACCEPTED'
    );
  };

  componentDidMount = async () => {
    const { getOrgMemberships, getOrganisationByAlias } = this.props;
    const { auth, isPublicUpload, user } = credentials.get() || {};
    const { email } = user || {};

    if (!auth) {
      this.setState({
        organisationMemberships: [],
        selectedOrganisation: null
      });
      return;
    }

    try {
      const { data, error } = email ?
      await getOrgMemberships() :
      { data: { getOrgMemberships: [] }, error: false };

      if (error || !data || !data.getOrgMemberships) {
        return void this.setState({ error: true });
      }

      const { getOrgMemberships: orgMembershipsData } = data;

      const orgMemberships = orgMembershipsData.
      map(({ organisation, ...membership }) => ({
        ...membership,
        organisation: formatOrganisation(organisation)
      }));

      if (!orgMemberships.length) {
        return void this.setState({
          organisationMemberships: [],
          selectedOrganisation: null
        });
      }

      const membershipsWithRoleId = orgMemberships.map(({ role, ...membership }) => ({
        ...membership,
        roleId: role.roleId,
        roleName: role.name
      }));

      const currentOrganisation = this.getCurrentOrganisation(membershipsWithRoleId);

      const currentOrgMembershipPending = currentOrganisation &&
      membershipsWithRoleId.some(({ organisation: { organisationId }, status }) =>
      organisationId === currentOrganisation.organisationId && status === 'PENDING'
      );

      if (currentOrgMembershipPending && !isPublicUpload) {
        return void this.setState({ redirect: '/user-settings/invite' });
      }

      const validOrgMemberships = orgMemberships.filter(({ status }) =>
      status === 'ACCEPTED'
      );

      if (!validOrgMemberships.length) {
        return void this.setState({
          organisationMemberships: [],
          selectedOrganisation: null
        });
      }

      if (currentOrganisation) {
        this.resolveOrgProfileImages(validOrgMemberships, currentOrganisation);

        return void this.setState({
          organisationMemberships: validOrgMemberships,
          selectedOrganisation: currentOrganisation
        });
      }

      // If we don't have a membership in the current org, check for shootsta membership
      const shootstaOrg = this.getShootstaOrganisation(validOrgMemberships);

      if (!shootstaOrg || !shootstaOrg.permissions || !shootstaOrg.permissions.length) {
        return void this.setState({
          organisationMemberships: [],
          selectedOrganisation: null
        });
      }

      // Need to fetch full org object to build temporary membership for shootsta user
      const {
        data: { getOrganisationByAlias: fetchedCurrentOrganisation },
        error: aliasError
      } = await getOrganisationByAlias(getAlias());

      if (aliasError || !fetchedCurrentOrganisation) {
        return void this.setState({ error: true });
      }

      // Give shootsta user their shootsta permissions on the current org
      this.setState({
        organisationMemberships: validOrgMemberships,
        selectedOrganisation: {
          ...formatOrganisation(fetchedCurrentOrganisation),
          permissions: shootstaOrg.permissions
        }
      });
    } catch (e) {
      this.setState({ error: true });
    }
  };

  render() {
    const { children } = this.props;
    const {
      selectedOrganisation,
      error,
      organisationMemberships,
      redirect
    } = this.state;

    if (redirect) {return <Redirect to={redirect} push />;}

    if (error) {return <Error />;}

    if (!organisationMemberships) {return null;}

    return (
      <AuthorisationContext.Provider value={this.getProviderValue(selectedOrganisation)}>
        {children}
      </AuthorisationContext.Provider>);

  }
}